/* eslint-disable */
export default {
  dialer: 'Teclado de marcação',
  allCalls: 'Todas as chamadas',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
